import { memo, useState, useRef } from 'react';
import FileIcon from '@mui/icons-material/InsertDriveFileOutlined';
//Local files
import { Root, Title, iconStyles, rootActiveStyles, FileInput } from './FileUploader.styled';
import ErrorWrapper from 'components/Common/ErrorWrapper/ErrorWrapper';

const FileUploader = ({ sx, onDrop, onFilesChange }) => {
  const [isDropFile, setIsDropFile] = useState(false);
  const inputRef = useRef(null);

  const handleDrop = (e) => {
    e.preventDefault();
    onDrop(e.dataTransfer.files);
    setIsDropFile(false);
  };
  const handleDragOver = (e) => {
    e.preventDefault();
    e.dataTransfer.dropEffect = "move"
    setIsDropFile(true);
  };
  const handleLeaveDrag = (e) => {
    e.preventDefault();
    setIsDropFile(false);
  };

  return (
    <Root
      onDrop={handleDrop}
      onDragOver={handleDragOver}
      onDragLeave={handleLeaveDrag}
      onClick={() => inputRef.current.click()}
      sx={{...(isDropFile && rootActiveStyles), ...sx}}
    >
      <FileInput
        ref={inputRef}
        accept='.pdf'
        type="file"
        onClick={(event) => event.target.value = ''}
        onChange={onFilesChange}
      />
      <FileIcon style={iconStyles} />
      <Title>Drag and drop a file or Upload</Title>
    </Root>
  );
}

const WrappedComponent = props => {
  return (
    <ErrorWrapper>
      <FileUploader {...props} />
    </ErrorWrapper>
  );
};

export default memo(WrappedComponent);